import { Card, ListItemText, MenuItem, MenuList, Paper, Typography } from '@mui/material';
import { FC } from 'react';
import { useNavigate, useParams } from 'react-router';
import { TVerticalMenuProps } from './types';

export const VerticalMenu: FC<TVerticalMenuProps> = ({ items, path }) => {
	const navigate = useNavigate();
	const params = useParams<{ typeOfReport?: string }>();
	const { typeOfReport } = params;

	const handleMenuItemClick = (index: number) => {
		navigate(path?.replace(':typeOfReport', items[index]?.path));
	};
	return (
		<Paper
			sx={{
				height: '100%',
				minHeight: { xs: 'auto', md: 'calc(100vh - 56px - 294px)' },
				mt: '-16px',
				boxShadow: 0,
				zIndex: 1,
				flex: '1 0 auto',
			}}
			className="vertical-menu"
		>
			<Card
				sx={{
					height: '100%',
				}}
			>
				<MenuList dense sx={{ pt: '30px' }}>
					{items?.map((item, index) => (
						<MenuItem
							key={item.path}
							onClick={() => handleMenuItemClick(index)}
							sx={{
								bgcolor: item.path === typeOfReport ? '#0092de24' : 'transparent',
								mb: '10px',
							}}
						>
							<ListItemText
								sx={{
									color: 'primary.main',
									fontWeight: 'bold',
									opacity: item.path === typeOfReport ? 0.8 : 1,
								}}
							>
								<Typography
									sx={{
										fontSize: '1rem',
										fontWeight: 'bold',
									}}
								>
									{item.title}
								</Typography>
								{item?.titleDescription && (
									<Typography
										sx={{
											fontSize: '0.8rem',
											p: 0,
											mt: '-5px',
										}}
									>
										{item?.titleDescription}
									</Typography>
								)}
							</ListItemText>
						</MenuItem>
					))}
				</MenuList>
			</Card>
		</Paper>
	);
};
